<template>
  <el-dialog
    v-model="showTerms"
    custom-class="terms-dialog"
    :lock-scroll="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    top="25px"
    center
  >
    <template #header>
      <div class="dialog-title">
        <div><strong>Terms and Conditions Update</strong></div>
        <p>By pressing 'I agree' button you agree to the Terms of Service</p>
      </div>
    </template>
    <TermsAndConditionsText />
    <template #footer>
      <div class="dialog-footer">
        <p>
          In case of disagreement with current Terms and Conditions please
          contact us via email
          <a class="color-primary" href="mailto:support@traforama.com">
            support@traforama.com
          </a>
          or your personal manager.
        </p>
        <el-button
          v-loading="loading"
          type="primary"
          :disabled="loading"
          @click.prevent="acceptTerms"
        >
          I agree
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import { useUserStore } from '@/store/modules/user'
import TermsAndConditionsText from '@/components/Terms/TermsAndConditionsText.vue'

export default defineComponent({
  name: 'Terms',
  components: {
    TermsAndConditionsText
  },
  setup() {
    const userStore = useUserStore()
    const loading = ref(false)

    const showTerms = computed(() => {
      return !(userStore.staff || userStore.termsAccepted)
    })

    const acceptTerms = async function () {
      loading.value = true
      try {
        await userStore.AcceptCurrentTerms()
      } finally {
        loading.value = false
      }
    }

    return { showTerms, acceptTerms, loading }
  }
})
</script>

<style lang="scss" scoped>
.dialog-title {
  font-size: 1.2em;

  @media only screen and (min-width: 767px) {
    font-size: 2em;
  }

  p {
    margin-top: 0;
  }
}
</style>

<style lang="scss">
@media only screen and (max-width: 767px) {
  .terms-dialog {
    width: 95%;
    max-height: 90vh;
    overflow: auto;
  }
}
</style>
